import { AsyncPipe, NgClass, NgComponentOutlet } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { ModalService } from '@core/services/modal.service';

@Component({
  selector: 'app-modal',
  imports: [AsyncPipe, NgComponentOutlet, NgClass],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent implements OnInit {
  private _cachedInjector!: Injector;

  constructor(
    public modalService: ModalService,
    private readonly _parentInjector: Injector,
  ) {}

  ngOnInit(): void {
    this.modalService.inputs$.subscribe((inputs) => {
      this._cachedInjector = Injector.create({
        providers: Object.entries(inputs).map(([key, value]) => ({
          provide: key,
          useValue: value,
        })),
        parent: this._parentInjector,
      });
    });
  }

  get dynamicInjector(): Injector {
    // Always return the same Injector reference
    return this._cachedInjector;
  }

  closeModal() {
    this.modalService.close();
  }

  onBackdropClick(event: MouseEvent) {
    this.closeModal();
    event.stopPropagation();
  }

  handleBackdropKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.closeModal();
    }
    event.stopPropagation();
  }
}
